var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.165,
    height: 69.292,
    viewBox: "0 0 56.165 69.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.41,
    x2: 0.5,
    y2: 2.248,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.302
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "android-stop",
    transform: "translate(0.002 -0.167)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    cx: 2.808,
    cy: 2.814,
    rx: 2.808,
    ry: 2.814,
    transform: "translate(25.273 63.83)",
    fill: "#95cf7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M23.6,70.279C10.218,69.335,0,64.226,0,58.068,0,51.238,12.573,45.7,28.081,45.7s28.081,5.538,28.081,12.367c0,6.14-10.162,11.232-23.485,12.2-3.894.8-4.6,2.64-4.6,2.64a7.949,7.949,0,0,0-4.48-2.629Z",
    transform: "translate(0 -10.016)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M23.6,55.969a28.081,28.081,0,1,1,9.076-.019,8.707,8.707,0,0,0-4.6,6S26.307,56.919,23.6,55.969Z",
    fill: "#95cf7d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "android",
    transform: "translate(16.38 12.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3328",
    "data-name": "Path 3328",
    d: "M-233.477,393.254h-8.168c-1.185,0-2.155-.634-2.155-1.408v-5.337c0-.775.97-1.408,2.155-1.408h8.168c1.185,0,2.155.634,2.155,1.408v5.337C-231.322,392.62-232.292,393.254-233.477,393.254Z",
    transform: "translate(249.436 -371.23)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2619",
    "data-name": "Group 2619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2613",
    "data-name": "Group 2613",
    transform: "translate(4.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3329",
    "data-name": "Path 3329",
    d: "M-219.415,349.192l1.086-1.827a.6.6,0,0,0-.212-.821.577.577,0,0,0-.457-.074.577.577,0,0,0-.364.286l-1.165,1.959a6.979,6.979,0,0,0-4.528,0l-1.165-1.959a.6.6,0,0,0-.821-.212.6.6,0,0,0-.212.821l1.086,1.827a7.084,7.084,0,0,0-3.733,6.249.616.616,0,0,0,.609.609h13a.6.6,0,0,0,.433-.176.6.6,0,0,0,.176-.433,7.084,7.084,0,0,0-3.733-6.249Zm-9.241,5.64a5.913,5.913,0,0,1,5.878-5.3,5.954,5.954,0,0,1,5.878,5.3Z",
    transform: "translate(229.9 -346.452)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2614",
    "data-name": "Group 2614",
    transform: "translate(13.985 6.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3330",
    "data-name": "Path 3330",
    d: "M-193.217,366.85v.609a.446.446,0,0,1-.131.319.446.446,0,0,1-.319.131h-.609a.425.425,0,0,1-.309-.134.425.425,0,0,1-.115-.316v-.609a.441.441,0,0,1,.424-.45h.609a.489.489,0,0,1,.318.132A.489.489,0,0,1-193.217,366.85Z",
    transform: "translate(194.7 -366.4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2615",
    "data-name": "Group 2615",
    transform: "translate(8.107 6.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3331",
    "data-name": "Path 3331",
    d: "M-215.417,366.85v.609a.441.441,0,0,1-.424.45h-.609a.446.446,0,0,1-.319-.131.446.446,0,0,1-.131-.319v-.609a.446.446,0,0,1,.131-.319.446.446,0,0,1,.319-.131h.609A.441.441,0,0,1-215.417,366.85Z",
    transform: "translate(216.9 -366.4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2616",
    "data-name": "Group 2616",
    transform: "translate(4.691 10.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3332",
    "data-name": "Path 3332",
    d: "M-215.767,383.485a.625.625,0,0,0-.424-.185h-13a.6.6,0,0,0-.433.176.6.6,0,0,0-.176.433v9.373a2.373,2.373,0,0,0,.7,1.688,2.373,2.373,0,0,0,1.688.7h.424v2.648a2,2,0,0,0,1.986,1.986,1.983,1.983,0,0,0,1.405-.581,1.983,1.983,0,0,0,.581-1.405v-2.648h.662v2.648a2,2,0,0,0,1.986,1.986,2,2,0,0,0,1.986-1.986v-2.648h.4a2.373,2.373,0,0,0,1.688-.7,2.373,2.373,0,0,0,.7-1.688v-9.373a.6.6,0,0,0-.163-.424Zm-3.813,11.571v3.257a.8.8,0,0,1-.794.794.78.78,0,0,1-.566-.228.78.78,0,0,1-.228-.566v-3.257a.616.616,0,0,0-.609-.609h-1.853a.616.616,0,0,0-.609.609v3.257a.78.78,0,0,1-.228.566.78.78,0,0,1-.566.228.8.8,0,0,1-.794-.794v-3.257a.616.616,0,0,0-.609-.609h-1.006a1.186,1.186,0,0,1-.844-.347,1.186,1.186,0,0,1-.347-.844v-8.764h11.809v8.79a1.187,1.187,0,0,1-.347.844,1.187,1.187,0,0,1-.844.348h-1.006a.583.583,0,0,0-.559.582Z",
    transform: "translate(229.8 -383.3)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2617",
    "data-name": "Group 2617",
    transform: "translate(20.08 10.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3333",
    "data-name": "Path 3333",
    d: "M-173.652,383.3a1.746,1.746,0,0,0-1.236.512,1.746,1.746,0,0,0-.511,1.236v6.487a1.746,1.746,0,0,0,.511,1.236,1.746,1.746,0,0,0,1.236.511,1.746,1.746,0,0,0,1.236-.511,1.746,1.746,0,0,0,.511-1.236v-6.461a1.752,1.752,0,0,0-.5-1.251,1.752,1.752,0,0,0-1.243-.523Zm-.556,1.774a.559.559,0,0,1,.556-.556.559.559,0,0,1,.556.556v6.487a.559.559,0,0,1-.556.556.559.559,0,0,1-.556-.556Z",
    transform: "translate(175.4 -383.3)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2618",
    "data-name": "Group 2618",
    transform: "translate(0 10.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3334",
    "data-name": "Path 3334",
    d: "M-242.053,383.3a1.746,1.746,0,0,0-1.236.512,1.746,1.746,0,0,0-.511,1.236v6.487a1.746,1.746,0,0,0,.511,1.236,1.746,1.746,0,0,0,1.236.511,1.769,1.769,0,0,0,1.774-1.747v-6.461a1.791,1.791,0,0,0-1.774-1.774Zm-.556,1.774a.559.559,0,0,1,.556-.556.559.559,0,0,1,.556.556v6.487a.559.559,0,0,1-.556.556.559.559,0,0,1-.556-.556Z",
    transform: "translate(243.8 -383.3)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.950d413bd63a8f509c45bde6db446a09.svg";
export { ForwardRef as ReactComponent };